import { LozengeSize } from '@/atoms/Lozenge/Lozenge'
import { PillBadgeSize, PillBadgeVariant } from '@/atoms/PillBadge/PillBadge'

const getSizeClassNames = (size: LozengeSize) => {
  switch (size) {
    case 'sm':
      return 'pill-badge-sm'
    case 'md':
      return 'pill-badge-md'
  }
}

const getVariantClassNames = (variant: PillBadgeVariant, isDarkMode: boolean) => {
  switch (variant) {
    case 'neutral':
      return isDarkMode ? 'bg-core-gray-900 text-core-gray-400' : 'bg-core-gray-200 text-core-gray-800'
    case 'outlined':
      return isDarkMode
        ? 'bg-transparent border border-core-gray-800 text-core-gray-400'
        : 'bg-transparent border border-core-gray-300 text-core-gray-800'
    case 'transparent':
      return isDarkMode ? 'bg-black/30 backdrop-blur-[48px] text-white' : 'bg-white/30 backdrop-blur-[48px] text-black'
    case 'blue':
      return isDarkMode ? 'bg-info-800 text-info-200' : 'bg-info-200 text-info-800'
    case 'brand':
      return 'bg-copper text-white'
    case 'warning':
      return 'bg-error-200 text-error-800'
    case 'error-500':
      return 'bg-error-500 text-white'
  }
}

export const getPillBadgeClassNames = (variant: PillBadgeVariant, size: PillBadgeSize, isDarkMode: boolean) => {
  return `${getSizeClassNames(size)} ${getVariantClassNames(variant, isDarkMode)}`
}
